import { render, staticRenderFns } from "./parkDetailsBox.vue?vue&type=template&id=03f6aebf"
import script from "./parkDetailsBox.vue?vue&type=script&lang=js"
export * from "./parkDetailsBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports